(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Mobile search toggle functionality
  document.addEventListener('DOMContentLoaded', function() {
    const searchIconButton = document.querySelector('.head-search-icon .search-icon-button');
    if (!searchIconButton) return;

    searchIconButton.addEventListener('click', function(event) {
      event.preventDefault();
      
      // Only trigger on mobile (viewport width < 990px)
      if (window.innerWidth >= 990) return;

      // Find the details-modal search element
      const searchModal = document.querySelector('details-modal.header__search');
      if (searchModal) {
        const detailsElement = searchModal.querySelector('details');
        const summaryElement = searchModal.querySelector('summary');
        
        if (detailsElement && !detailsElement.hasAttribute('open')) {
          // Try to use the details-modal's open method
          if (summaryElement && typeof searchModal.open === 'function') {
            searchModal.open({ target: summaryElement });
          } else if (detailsElement) {
            // Fallback: manually open the details element
            detailsElement.setAttribute('open', true);
            document.body.classList.add('overflow-hidden');
            
            // Focus the search input after a short delay
            setTimeout(function() {
              const searchInput = searchModal.querySelector('input[type="search"]');
              if (searchInput) {
                searchInput.focus();
              }
            }, 100);
          }
        }
      } else {
        // If no details-modal found, try to find any search form and show it
        const searchForm = document.querySelector('.header__search form, .search-modal__form');
        if (searchForm) {
          searchForm.closest('details')?.setAttribute('open', true);
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery"] && !Shopify.designMode) return;
  try {
    
lightbox.option({
  resizeDuration: 200,
  wrapAround: true,
  fadeDuration: 300,
  imageFadeDuration: 300
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offer-details"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll(".offer-section .offer-inner .offer-box .offer-code").forEach(function(copyBtn) {
   copyBtn.addEventListener("click", function() {
    var thisOffer = copyBtn.closest('.offer-box');
    
    document.querySelectorAll(".offer-section .offer-inner .offer-box").forEach(function(box) {
      box.classList.remove('active');
    });
    
    var input = copyBtn.querySelector('input');
    if (input) {
      input.select();
      input.setSelectionRange(0, 99999);
      document.execCommand("copy");
    }

    thisOffer.classList.add('active');
    
    setTimeout(function() {
      thisOffer.classList.remove('active');
    }, 2000);
  });
});

  } catch(e) { console.error(e); }
})();
})();
